import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-custom-public-first',
    templateUrl: './custom-public-first.component.html',
    styleUrls: ['./custom-public-first.component.scss'],
    standalone: false
})
export class CustomPublicFirstComponent {
  constructor(public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig,private cd: ChangeDetectorRef) { }
  publicnode: Observable<any> = this.bannerComponent.data$;
  link:any;
  openModal(everylink:any) {
    document.body.style.overflowY = 'auto';
    this.link=everylink;
    document.getElementById('commonleaving_abandonedPop')!.style.display = 'block';
    this.cd.detectChanges()
  }
  closeModal() {
    this.link=""
    document.body.style.overflowY = 'auto';
    document.getElementById('commonleaving_abandonedPop')!.style.display = 'none';
  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }
}
